// Vanilla jQuery Ajax isn't aware of Rails CSRF protection. This appends
// the CSRF token to each Ajax request as an HTTP header so long as the
// Rails CSRF meta tag is present in the document.

(function(){
  // If CSRF meta tag is present, include a CSRF header in each Ajax request
  if ($('meta[name=csrf-token]')) {
    var csrfToken = $('meta[name=csrf-token]').attr('content');
    $.ajaxSetup({
      headers: {'X-CSRF-Token': csrfToken}
    });
  }
})();
